import { createAction, props } from '@ngrx/store';

export const changeLanguage = createAction('[language Component] ChangeLanguage', props<{ parameters: string }>());
